import {
	type AccessLevel,
	PRIVATE_ACCESS_LEVEL,
	LIMITED_ACCESS_LEVEL,
	OPEN_ACCESS_LEVEL,
} from '@atlassian/jira-shared-types/src/project.tsx';

export const transformAccessLevel = (accessLevelRaw: string): AccessLevel | undefined => {
	switch (accessLevelRaw) {
		case 'PRIVATE':
			return PRIVATE_ACCESS_LEVEL;
		case 'LIMITED':
			return LIMITED_ACCESS_LEVEL;
		case 'OPEN':
			return OPEN_ACCESS_LEVEL;
		default:
			return undefined;
	}
};
